import { getId } from '@app/utils/getId';
export const signorLinkExists = (signorLinks, userId) => {
    if (!signorLinks) {
      return false;
    }
    const hasMatchingSignorWithLink = signorLinks.some(signor => {
        return getId(signor) === userId && signor.signorLink;
    });
    return hasMatchingSignorWithLink;
}